































import { Component, Vue } from "vue-property-decorator";
import { AuthModule } from "@/store/auth.module";
import NotificationPowerConsumptionModal from "./NotificationPowerConsumptionModal.vue";

@Component({
  components: {
    NotificationPowerConsumptionModal,
  },
})
export default class SingleReportUnwrapped extends Vue {
  formRef = "form";
  docGuid: string;
  public async clickInstr() {
    AuthModule.setShowConsumptionNotification(true);
  }
}
